import { pathOr } from 'ramda';
import {
  template_config
} from 'src/utilities/notifications/templateConfig';
import SiteSettings from 'src/siteSetting';

// template types
export const SIGNUP = 'signup';
export const RESET_PASSWORD = 'reset_password';
export const MIN_STRONG = 16
export const MIN_MODERATE_STRONG = 8

// 0001 general invite
export const ZERO_GENERAL = '0001_general_invite_template.hbs';
export const THIRTY_THREE_INFORM_ADVISOR = '0033_inform_advisor_need.hbs';

// 0003 reset password section
const RESET_PASSWORD_TEMPLATE = '0003_reset_password';
const RESET_PASSWORD_SUBJECT = 'Password reset request.';
const RESET_PASSWORD_SMS_SUBJECT = (name: string, lender: string) => {
  return `Hi ${name}, You had requested to change the password with ${lender}.`;
};
const RESET_PASSWORD_STATIC_URL = '/u/reset_password';

// reset password notification config
export const reset_password_template_config = (options: any) => {
  const borrowerName = pathOr('', ['borrowerName'], options);
  return template_config(
    '0003',
    RESET_PASSWORD,
    RESET_PASSWORD_SUBJECT,
    RESET_PASSWORD_SMS_SUBJECT(borrowerName, SiteSettings.generalAppTitle()),
    RESET_PASSWORD_STATIC_URL,
    RESET_PASSWORD_TEMPLATE
  );
};